export default function sortWord(word: any) {
  var newword = word.split("").sort().join("");
  return newword;
}
